export default function progressBarWidget(editor) {
  editor.DomComponents.addType('eb-progress-bar', {
    isComponent(el) {
      return el.getAttribute && el.getAttribute('data-gjs-type') === 'eb-progress-bar'
    },
    model: {
      defaults: {
        name: 'Progress Bar',
        tagName: 'div',
        droppable: false,
        attributes: { 'data-gjs-type': 'eb-progress-bar', 'data-percent': '75' },
        style: { 'padding': '10px' },
        components: `
          <div style="margin-bottom:6px;display:flex;justify-content:space-between;align-items:center;">
            <span style="font-size:14px;font-weight:600;color:#333;">Web Development</span>
            <span style="font-size:13px;font-weight:600;color:#667eea;">75%</span>
          </div>
          <div style="width:100%;height:12px;background:#e8e8e8;border-radius:6px;overflow:hidden;">
            <div style="width:75%;height:100%;background:linear-gradient(90deg,#667eea,#764ba2);border-radius:6px;transition:width 0.6s;"></div>
          </div>
        `,
        traits: [
          { type: 'number', name: 'data-percent', label: 'Percentage (0-100)', min: 0, max: 100, changeProp: true },
          { type: 'text', name: 'data-label', label: 'Label' },
          { type: 'color', name: 'data-bar-color', label: 'Bar Color' },
        ],
      },
      init() {
        this.on('change:attributes:data-percent', this.updateBar)
      },
      updateBar() {
        const pct = Math.min(100, Math.max(0, parseInt(this.getAttributes()['data-percent'] || '75', 10)))
        const label = this.getAttributes()['data-label'] || 'Progress'
        const pctEl = this.components().at(0)
        if (pctEl) {
          const labelEl = pctEl.components().at(0)
          const numEl = pctEl.components().at(1)
          if (labelEl) labelEl.set('content', label)
          if (numEl) numEl.set('content', `${pct}%`)
        }
        const trackEl = this.components().at(1)
        if (trackEl) {
          const bar = trackEl.components().at(0)
          if (bar) bar.setStyle({ ...bar.getStyle(), width: `${pct}%` })
        }
      },
    },
  })

  editor.BlockManager.add('eb-progress-bar', {
    label: 'Progress Bar',
    category: 'Utility',
    media: '<svg viewBox="0 0 24 24"><path fill="currentColor" d="M13,2V4C17.39,4.54 20.5,8.53 19.96,12.92C19.5,16.56 16.64,19.43 13,19.88V21.88C18.5,21.28 22.45,16.34 21.85,10.85C21.33,6.19 17.66,2.5 13,2M11,2C9.04,2.18 7.19,2.95 5.67,4.2L7.1,5.74C8.22,4.84 9.57,4.26 11,4.06V2M4.26,5.67C3,7.19 2.24,9.04 2.05,11H4.05C4.24,9.58 4.8,8.23 5.69,7.1L4.26,5.67M2.06,13C2.26,14.96 3.03,16.81 4.27,18.33L5.69,16.9C4.81,15.77 4.24,14.42 4.06,13H2.06M7.06,18.37L5.67,19.74C7.18,21 9.04,21.79 11,22V20C9.58,19.82 8.23,19.25 7.1,18.37H7.06M13,13V7H11V13H13Z"/></svg>',
    content: { type: 'eb-progress-bar' },
  })
}
